import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core'

@Component({
  selector: 'cm-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit, AfterViewInit {

  @ViewChild('spinner')
  private spinnerRef: ElementRef

  public config: any = {
    path: '/assets/animations/spinner/real.json',
    autoplay: true,
    loop: true
  }

  constructor() { }

  ngOnInit() {

  }

  ngAfterViewInit() {
    const animData = {
        wrapper: this.spinnerRef.nativeElement,
        animType: 'svg',
        loop: true,
        autoplay: true,
        path: '/assets/animations/spinner/real.json'
    }

    bodymovin.setQuality('low')
    return bodymovin.loadAnimation(animData)
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/spinner/spinner.component.ts